// Hook odpowiedzialny za usunięcie produktu z listy zakupowej typu (np. FAVORITES)

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

type IResponse = ICommandResponseSuccess;

const deleteShoppingListTypeProduct = (
  shoppingListType: string,
  productId: number,
  unitId: number
): Promise<IResponse> =>
  axios.delete(`/shopping-lists/types/${shoppingListType}/${productId}/${unitId}`);

export const useDeleteShoppingListTypeProduct = (
  shoppingListType: string,
  productId: number,
  unitId: number,
  options?: UseMutationOptions<IResponse, IError>
) =>
  useMutation(
    () => deleteShoppingListTypeProduct(shoppingListType, productId, unitId),
    options
  );
